var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Grupo",
      "outlined": "",
      "maxlength": "40",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.grupo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "grupo", $$v);
      },
      expression: "form.filters.grupo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.form.lists.origens,
      "label": "Origem",
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.origem,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "origem", $$v);
      },
      expression: "form.filters.origem"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarGrupos();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterGrupo();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.situacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.situacao
          }
        })];
      }
    }, {
      key: `item.origem`,
      fn: function (_ref2) {
        var _item$origem;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm._f("uppercase")((_item$origem = item.origem) === null || _item$origem === void 0 ? void 0 : _item$origem.nome)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar Grupo",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarGrupo(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar Grupo",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterGrupo(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Excluir Grupo",
            "icon": "mdi-delete",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.excluirGrupo(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'} Grupo`,
            "icon": `${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.situacao ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.alterarStatusGrupo(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogVisualizarGrupo.visible ? _c('VisualizarGrupoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarGrupo.visible,
      "content": _vm.dialogVisualizarGrupo.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarGrupo.close();
      }
    }
  }) : _vm._e(), _c('CadastrarEditarGrupoDialog', {
    attrs: {
      "tipos": _vm.form.lists.tipos,
      "edit": _vm.dialogManterGrupo.edit,
      "visible": _vm.dialogManterGrupo.visible,
      "content": _vm.dialogManterGrupo.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterGrupo.close();
      },
      "onSave": function ($event) {
        return _vm.buscarGrupos();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }